/** Estado vacio con icono, mensaje y accion opcional. */
import { MobileButton } from './MobileButton';
import { MobileIcon, type MobileIconName } from './MobileIcon';

type EmptyStateProps = {
  icon?: MobileIconName;
  title: string;
  description?: string;
  actionLabel?: string;
  actionIcon?: MobileIconName;
  onAction?: () => void;
};

export function EmptyState({
  icon = 'inbox',
  title,
  description,
  actionLabel,
  actionIcon = 'add',
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-bg-tertiary">
        <MobileIcon name={icon} className="h-9 w-9 text-text-tertiary" />
      </div>

      <h3 className="mb-2 text-lg font-semibold text-text-primary">
        {title}
      </h3>

      {description && (
        <p className="mb-6 max-w-xs text-sm text-text-secondary">
          {description}
        </p>
      )}

      {actionLabel && onAction && (
        <MobileButton
          variant="primary"
          size="md"
          onClick={onAction}
          icon={<MobileIcon name={actionIcon} className="h-5 w-5" />}
        >
          {actionLabel}
        </MobileButton>
      )}
    </div>
  );
}

/** Estado de error con reintento. */
type ErrorStateProps = {
  title?: string;
  description?: string;
  onRetry?: () => void;
};

export function ErrorState({
  title = 'Algo salió mal',
  description = 'No se pudo cargar la información. Intenta de nuevo.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-error-light">
        <MobileIcon name="error" className="h-9 w-9 text-error" />
      </div>

      <h3 className="mb-2 text-lg font-semibold text-text-primary">
        {title}
      </h3>

      <p className="mb-6 max-w-xs text-sm text-text-secondary">
        {description}
      </p>

      {onRetry && (
        <MobileButton
          variant="primary"
          size="md"
          onClick={onRetry}
          icon={<MobileIcon name="refresh" className="h-5 w-5" />}
        >
          Reintentar
        </MobileButton>
      )}
    </div>
  );
}
